import { IProductBase, IProductDeleteParams, IProductReservationBase, IProductReservationParams } from '../../../model/product.interface';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { IHotelProduct, RoomConfigurationItem } from 'model/hotel-product.interface';
import { IProductCreationParams } from 'model/product.interface';
import { getServiceExtra, keyRandomUnique } from 'utils/helpers';
import { BaseProductService } from './base-product.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Injectable({
  providedIn: 'root'
})
export class HotelProductService extends BaseProductService {
  deleteProduct(params: IProductDeleteParams): IProductBase {
    throw new Error('Method not implemented.');
  }

  private roomDist: any[] = [];
    bsModalRef?: BsModalRef;

  createProduct(params: IProductCreationParams): IHotelProduct {
console.log(params)
    const { item, product, payload, othersPerCategory} = params;
    const form = JSON.parse(localStorage.getItem('form'));

    this.commonsValueProduct(item, product, payload, form);
    this.applyAddonsIfNeeded(item, payload);
    this.setupHotelSpecificProperties(item, product);
    this.setupRoomConfiguration(item, form, othersPerCategory);
    this.setupPricing(item);
    item.payloadUpdate = this.createPayloadUpdate(item, product, payload, form);
    item.payloadOriginal = this.getPayloadOriginalInfo(item, product, payload, form, othersPerCategory);
    console.log(item)
    item.destination = this.itineraryService.getDestinationInfo(form, item);

    return item as IHotelProduct;
  }

  validateProduct(item: any): boolean {
    return !!(item?.room?.roomId && item?.hotelCode && item?.arrivalDate && item?.departureDate);
  }

  private commonsValueProduct(item: any, product: any, payload: any, form: any): void {
      item.id = item.room.roomId;
      item.categoryId = 1;
      item.categoryName = 'HOTELS';
      item.providerId = product.providerId;
      item.providerName = product.providerName;
      item.nameAdapter = product.nameAdapter;
      item.title = item.title;
      item.currency = item.room.pricing.currency;
      item.updateDate = new Date();
      item.arrivalDate = item.stay.startDate;
      item.departureDate = item.stay.endDate;
  }

    private applyAddonsIfNeeded(item: any, payload: any): void {
    if (item.room.netPriceBookingAddons && item.room.netPriceBookingAddons > 0) {
      item.room.profility = this.getProfilityAddons(item);
      this.adjustPricingWithAddons(item);
    }
  }

  private setupHotelSpecificProperties(item: any, product: any): void {
    const additionalInfo = [...product.additionalInfo];

    item.categoryName = "HOTELS";
    item.title = product?.title;
    item.location = product?.additionalInfo?.location;
    item.hotelAdditionalInfo = additionalInfo;
    item.hotelAdditionalInfo.coordinates = product.coordinates;
    item.checkTimes = product?.additionalInfo?.TimeInformation;
    item.flightMandatory = this.hasFlightMandatory(item);
    item.serviceExtra = this.getServiceExtra(item);
  }

  private setupPricing(item: any): void {
    item.optionNightsNetTotalProf = item?.room?.optionNightsNetTotalProf || 0;
    item.taxes = item?.room?.pricing?.taxes || [];
    item.netPriceProf = item?.room?.netPriceProf || null;
    item.optionNightsNetTotalFreeTax = item?.room?.optionNightsNetTotalFreeTax || 0;
    item.netPriceFreeTax = item.room?.netPriceFreeTax || 0;
    item.taxPrice = 0;
    item.taxNightsPriceTotal = this.calculateTaxes(item?.room?.pricing?.taxes);
    // Solo para mostrarlo (ej. un tooltip futuro) — no se suma a ningún total del item.
    // Productos creados antes de este cambio no van a tener este valor al leerlos del backend,
    // así que quien lo consuma más adelante tiene que tratarlo como opcional.
    item.taxesExcluded = item?.room?.pricing?.taxesExcluded ?? undefined;
  }

  private setupRoomConfiguration(item: any, form: any, othersPerCategory: any): void {
    const roomDescriptionIndex = this.getRoomDescriptionIndex(form, othersPerCategory);
    this.generateProductKeys(othersPerCategory.selectedRooms);

    form.room = roomDescriptionIndex;
    item.form = form;
  }

  private getRoomDescriptionIndex(form: any, othersPerCategory: any): any {
    if (othersPerCategory.selectedRooms.length <= 1) {
      return form.room[othersPerCategory.indexRoom[0]];
    }
    return form.room[othersPerCategory.roomIndex];
  }

  private generateProductKeys(selectedRooms: any[]): void {
    selectedRooms.forEach(room => {
      let uniqueKey = keyRandomUnique();
      while (selectedRooms.some(r => r.room.productKey === uniqueKey)) {
        uniqueKey = keyRandomUnique();
      }
      room.room.productKey = uniqueKey;
    });
  }

  private getProfilityAddons(item: any): any {
    return {
          netPrice: item?.room?.profility?.netPrice + item?.room?.netPriceBookingAddons,
          netPriceBooking: item?.room?.profility?.netPriceBooking + item?.room?.netPriceBookingAddons,
          netPriceCategory: item?.room?.profility?.netPriceCategory + item?.room?.netPriceBookingAddons,
          netPriceProvider: item?.room?.profility?.netPriceProvider + item?.room?.netPriceBookingAddons,
          percentage: item?.room?.profility?.percentage,
          percentageBooking: item?.room?.profility?.percentageBooking,
          percentageCategory: item?.room?.profility?.percentageCategory,
          percentageProvider: item?.room?.profility?.percentageProvider,
          blickoins: item?.room?.profility?.blickoins,
          creditBlickoins: item?.room?.profility?.creditBlickoins
    };
  }

  private adjustPricingWithAddons(item: any): void {
    item.room.optionNightsNetTotalProf += item?.room?.netPriceBookingAddons;
    item.room.netPriceProf += item?.room?.netPriceBookingAddons;
    item.room.optionNightsNetTotalFreeTax += item?.room?.netPriceBookingAddons;
    item.room.netPriceFreeTax += item?.room?.netPriceBookingAddons;
  }

  private hasFlightMandatory(item: any): boolean {
    return item.room.extras && item.room.extras.length > 0
      ? item.room.extras.some(c => c.requiresflightdetails === true)
      : false;
  }

  private getServiceExtra(item: any): any[] {
    const arr: any[] = [];
    if (item.room.addonsIncluded && item.room.addonsIncluded.length) {
      item.room.addonsIncluded.forEach((addon: any) => {
        arr.push({ name: addon.title, price: addon.netcost.amount });
      });
    }
    return arr;
  }

  private createPayloadUpdate(item: any, product: any, payload: any, form: any): any[] {
    console.log(item)
    console.log(product)
    const others = {
      agedriver: environment.agedriver,
      serialized: environment.serialized,
      maxRequestTimeOnSeconds: environment.maxRequestTimeOnSeconds,
      minNumResults: environment.minNumResults,
      maxNumResultsPerAdapter: environment.maxNumResultsPerAdapter,
      hotels: {
        roomConfiguration: this.getRoomDist(form, product, item),
      },
    };

    return [{
      products: [{
        providerId: item.providerId,
        nameAdapter: item.nameAdapter,
        categoriesId: [1],
        productId: item.room.hotelCode,
        productName: item.title,
        origin: product.origin,
        destination: product.destination,
        city: " ",
        priceFrom: 0,
        priceTo: 0,
        arrivalDate: item.arrivalDate,
        departureDate: item.departureDate,
        qtyProduct: 1,
        qtyPax: item.room?.availability.maxPax,
        others: others,
        agencyId: payload.agencyId,
        nationality: form.nationality,
        country: payload.country,
      }]
    }];
  }

  private getRoomDist(form: any, item: any, itemSelected: any): any[] {
    const roomDist = [];
    const rooms = Array.isArray(form.room) ? form.room : [form.room];

    for (const room of rooms) {
      const dist = {
        adults: room.qtyAdults,
        children: room.childsage?.map((child: any) => child.age) || [],
        boardNameCode: item.boardNameCode,
        condition: item.rateClassId,
        roomId: item.roomId,
        roomCode: item.roomCode,
        bookingCode: item.bookParam,
        extras: getServiceExtra(itemSelected.room.addonsIncluded, 1),
      };
      roomDist.push(dist);
    }
    return roomDist;
  }

  private getPayloadOriginalInfo(item: any, product: any, payload: any, form: any, othersData: any): any {
console.log(payload)
console.log(item)
console.log(product)
    const formLength = form.room.length;
console.log(othersData)
      this.getRoomDistOriginal(item, product, payload, form, othersData);
      if(othersData.selectedRooms.length < formLength) {
        const dist = this.roomDist.filter((_, index) => index < formLength);
        this.roomDist = dist;
      }
      const others = {
        agedriver: environment.agedriver,
        serialized: environment.serialized,
        maxRequestTimeOnSeconds: environment.maxRequestTimeOnSeconds,
        minNumResults: environment.minNumResults,
        maxNumResultsPerAdapter: environment.maxNumResultsPerAdapter,
        hotels: {
          roomConfiguration: this.roomDist,
        },
      };


    payload = {
      products: [
        {
          providerId: item.providerId,
          nameAdapter: item.nameAdapter,
          categoriesId: [1], // Hotel
          productId: item.room.hotelCode,  //this.hotel.id,//
          productName: item.title,
          origin: product.origin,
          destination: product.destination,
          city: " ", //form.destination.cityName,
          priceFrom: 0,
          priceTo: 0,
          arrivalDate: item.arrivalDate,
          departureDate: item.departureDate,
          qtyProduct: 1,
          qtyPax: payload.qtyPax,
          others: others,
          agencyId: payload.agencyId,
          nationality: form.nationality
        },
      ],
    };

    return payload;

  }


getRoomDistOriginal(item: any, product: any, payload: any, form: any, othersData: any): any[] {
      let roomsArr = [];
      const rooms = form.room;
      const formLength = form.room.length;
      roomsArr.push(rooms)
console.log(othersData)
      if(othersData.selectedRooms.length < formLength) {

        for (let i = 0; i < roomsArr.length; i++) {
          this._roomsOriginal(form,item, formLength, othersData);
        }

      } else if (othersData.selectedRooms.length == formLength) {
        for (let i = 0; i < roomsArr.length; i++) {

          const people = [];
          const dist: RoomConfigurationItem = {
            adults: 0,
            children: [],
            boardNameCode: item.boardNameCode,
            condition: item.rateClassId,
            roomId:item.roomId,
            roomCode:item.roomCode,
            bookingCode: item.bookParam,
            extras:  getServiceExtra(item.room.addonsIncluded, 1)
          };
          const adults = rooms.qtyAdults;
          const children = rooms.childsage;
          for (let j = 0; j < children.length; j++) {
            people.push(children[j].age);
          }
          dist.adults = adults;
          dist.children = people;

          this.roomDist.push(dist);

      }

      return this.roomDist;
      }
}

  _roomsOriginal(form: any, item: any, formLength: any, othersData: any) {
    const rooms = form.room;
    const roomsArr = [];

    // Agregar elementos a roomsArr
    for(let i = 0; i < othersData.selectedRooms.length; i++) {
      roomsArr.push(othersData.selectedRooms[i].room);
    }

    for (let i = roomsArr.length; i < formLength; i++) {
      const newItem = { ...item }; // Clonar el elemento inicial en cada iteración
      newItem.boardNameCode = -1;
      newItem.condition = -1;
      newItem.roomId = -1;
      newItem.roomCode = -1;
      newItem.bookingCode = -1;
      roomsArr.push(newItem); // Agregar el clon al array
    }

    for (let i = 0; i < roomsArr.length; i++) {

      const people = [];
      const dist: RoomConfigurationItem = {
        adults: 0,
        children: [],
        boardNameCode: roomsArr[i].boardNameCode,
        condition: roomsArr[i].rateClassId,
        roomId: roomsArr[i].roomId,
        roomCode: roomsArr[i].roomCode,
        bookingCode: roomsArr[i].bookParam,
         extras: getServiceExtra(item.room.addonsIncluded, 1),
      }
      const adults = rooms.qtyAdults;
      const children = rooms.childsage;
      for (let j = 0; j < children.length; j++) {
        people.push(children[j].age);
      }
      dist.adults = adults;
      dist.children = people;
      this.roomDist.push(dist);

    }
    return this.roomDist;
  }


  private calculateTaxes(data: any): number {
    let taxSum: number = 0;
    if (data && data.length > 0) {
      data.forEach((tax) => {
              // Verifica si 'included' es un booleano verdadero
              if (typeof tax.included === 'boolean' && tax.included) {
                // Si 'included' es true, suma el impuesto al total
                taxSum += tax.amount;
              }
            });
          }

          return taxSum;
  }

  createReserve(params: IProductReservationParams): IProductReservationBase {

    const {  item, paxes, itineraryId, othersPerCategory } = params;

    // const productReserve: ReservationIInsuranceProduct = {



    // }



    return;
  }

//   removeProduct(params: any): any {

//      const {  item, paxes, itineraryId, othersPerCategory } = params;

//          let message = "";

//          if ((item.status_id == 1) ||  (item.status_id == 5)) {
//            message = "Esta seguro de Eliminar el Producto?";
//          }
//          if (item.status_id == 2) {
//            if(this.verifiedReservationId(item)) {
//              message = "Hay más productos con el mismo localizador ¿Está seguro de cancelar los productos?";
//            } else {
//              message = "¿Esta seguro de cancelar el producto?";
//            }
//          }

//          const initialState: ModalOptions = {
//            initialState: {
//              message: message
//            }
//          };

//          this.bsModalRef = this.modalService.show(MaterialModalConfirmComponent, initialState);
//          const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
//            if(result) {
//                const paxesQty = {
//                  destination: item.destination?.iata_code,
//                  adults: Number(item.paxAdults),
//                  children: Number(item.paxChildren)
//                }
//                this.userService.itineraryActive[0]['destination'].forEach((destination: any) => {
//                    if(destination.iata_code === paxesQty.destination) {
//                      destination.destination_info.adults -= paxesQty.adults;
//                      destination.destination_info.childs -= paxesQty.children;
//                    }
//                });
//              if((item.status_id == 1) ||  (item.status_id == 5) ) {

//                this.deleteItem(item);
//              }
//              if (item.status_id == 2) {
//                this.cancelReservation(item, othersPerCategory);
//              }
//            } else {

//            }
//            confirmSubscription.unsubscribe();
//          });

//   }

//     verifiedReservationId(item): boolean {
//       let matchReservationId: any[] = [];

//       matchReservationId = this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId);

//       return matchReservationId && matchReservationId.length > 1;
//   }

//     deleteItem(item: IHotelProduct) {
//     this.itineraryService.remove(item !== undefined ? item : item);
//     setTimeout(() => {
//       // this.delete.emit(item.id);
//      this.userService.updateProductsPrices(item.itinerary_id);
//     }, 1000);
//   }

//    cancelReservation(item: any, othersData: any) {


//       const productsIdArr = item.map(c => c.id);


//       this.ngxSpinner.show();
//       let cancelData: any = {};

//           cancelData['providerId'] = item?.providerId
//           cancelData['reservationLocator'] = item?.resultReserve?.providerReservationId;
//           cancelData['productsId'] = productsIdArr;

//           const itemCancelled = this.userService.itineraryActive[0].items.find(c => c.id === item.id);

//           itemCancelled.amount_convert_cancellation= this.getCancellationPolicies(itemCancelled.category_id, item);
//           this.userService.itineraryActive[0].clientId = this.itineraryService.itinerary.client_id;

//           console.log(JSON.stringify(cancelData));
//           this.restService.doPut("app", `products/cancelReservation/${item?.itinerary_id}`, cancelData).subscribe({
//             next: (res: any) => {
//               this.ngxSpinner.hide();
//               // this.cancel.emit(item.id);
//             this.itineraryService.updateItinerary(this.userService.itineraryActive[0], false);
//           },
//           error: (error: HttpErrorResponse) => {
//             this.ngxSpinner.hide();
//             console.log(error);
//           }
//         });
//     }

//     getCancellationPolicies(category, item) {
//     const currentDate = new Date();
//     const defaultPolicy = {
//         currency: .currencyAgency?.code,
//         from: currentDate,
//         amount: 0,
//         apply: false
//     };

//     // Determinar el array de políticas según la categoría
//     let policies = [];
//     if (category === 1) {
//         policies = item.room?.cancellationPolicy || [];
//     } else if (category === 8) {
//         policies = item.cancellationPolicies || [];
//     }

//     // Si no hay políticas, retornar el default
//     if (policies.length === 0) {
//         return [defaultPolicy];
//     }

//     // Ordenar políticas por fecha 'from'
//     const sortedPolicies = [...policies].sort((a, b) =>
//         new Date(a.from).getTime() - new Date(b.from).getTime()
//     );

//     // Encontrar la política aplicable
//     let applicableIndex = -1;
//     for (let i = 0; i < sortedPolicies.length; i++) {
//         if (new Date(sortedPolicies[i].from) <= currentDate) {
//             applicableIndex = i;
//         } else {
//             break;
//         }
//     }

//     // Preparar el resultado con el campo apply
//     const result = sortedPolicies.map((policy, index) => {
//       const baseRate = this.currencies.find(c => c.code === policy.currency)?.rate || 1;
//       const targetRate = this.currencyAgency?.rate || 1;

//         const isApplicable = index === applicableIndex;
//         const amount = (policy.amount / baseRate) * targetRate;

//         return {
//             ...policy,
//             currency: this.currencyAgency?.code,
//             amount: amount,
//             apply: isApplicable
//         };
//     });

//     // Si no hay ninguna aplicable y hay políticas, marcamos todas como no aplicables
//     if (applicableIndex === -1 && result.length > 0) {
//       const targetRate2 = this.currencyAgency?.rate || 1;
//       return result.map(policy => ({
//             ...policy,
//             currency: this.currencyAgency?.code,
//             amount: (policy.amount / this.currencies.find(c => c.code === policy.currency)?.rate) * targetRate2,
//             apply: false
//         }));
//     }

//     return result;
// }



}
